import React from 'react';
import pickBy from "lodash/pickBy";
import {Inertia} from "@inertiajs/inertia";

const TableHeadSort = ({
                         title,
                         sortName,
                         customClassName = "px-6 pt-5 pb-4",
                         itemId
}) => {
  const [params, setParams] = React.useState({
    sort: sortName,
    typeSort: 'asc',
  });
  const handleSort = () => {
    setParams(prevState => ({...prevState, typeSort: prevState.typeSort === 'asc' ? 'desc' : 'asc'}));

    const query = pickBy({sort: `${params.sort}-${params.typeSort}`});
    let url
    if (itemId) {
      url = route(route().current(), itemId)
    } else {
      url = route(route().current())
    }
    Inertia.get(url, query, {
      replace: true,
      preserveState: true
    });
  }

  return (
    <th className={customClassName + " cursor-pointer hover:bg-gray-100"} onClick={handleSort}>{title}</th>
  );
};

export default TableHeadSort;
